import type { UseDebouncedValueResult } from './useDebouncedValue';
import useDebouncedValue from './useDebouncedValue';

interface UseDebouncedQueryTermOptions {
  /** The input term. */
  queryTerm: string;

  /** The minimum length of the query term. If it is shorter, it will be treated as blank. */
  queryTermThreshold?: number;

  /** How long to wait before updating the value in ms. */
  delay?: number;
}

/**
 * A wrapper around {@link useDebouncedValue} intended for use with search boxes
 * @param options configuration object
 * @returns The debounced value
 */
export default function useDebouncedQueryTerm(
  options: UseDebouncedQueryTermOptions
): UseDebouncedValueResult<string> {
  const { delay = 500, queryTerm, queryTermThreshold = 3 } = options;

  return useDebouncedValue(queryTerm, {
    canUpdateValue(value) {
      return value.length >= queryTermThreshold;
    },
    clearValue: '',
    delay
  });
}
